import { Redirect } from 'react-router-dom';
import {
  BILLING_DETAILS_PATH,
  BILLING_USAGE_PATH,
  BILLING_CHANGE_PLAN_PATH,
} from '../subroutes';
import { useBillingPermissions } from 'ts-components/hooks/permissions/billing';

export const BillingRootPage = () => {
  // For now, just redirect to usage
  const billingPermissions = useBillingPermissions();

  if (!billingPermissions.canSelfServeBilling) {
    return <Redirect to="/" />;
  }

  if (billingPermissions.canViewUsage) {
    return <Redirect to={BILLING_USAGE_PATH} />;
  }

  if (billingPermissions.canManagePlans) {
    return <Redirect to={BILLING_CHANGE_PLAN_PATH} />;
  }

  if (billingPermissions.canViewPaymentMethods) {
    return <Redirect to={BILLING_DETAILS_PATH} />;
  }

  return <Redirect to="/" />;
};
